export enum UserTypeEnum {
	INTERNAL = 'internal',
	EXTERNAL = 'external',
	ADMIN = 'admin'
}
